import { getData } from './common.service';

export async function listTerritories() {
  const qs = {
    fields: { id: true, name: true },
    where: { disabled: { neq: true } },
    order: ['name ASC'],
  };
  return getData(`/territories?filter=${JSON.stringify(qs)}`, {
    sendTokenInHeader: true,
    basePath: process.env.REACT_APP_CORE_API_BASEPATH,
  }).then(res => res.json());
}

export async function getProductivityScore(
  territoryId: string,
  farmUserId: string,
  month: number,
  year: number
) {
  const url = `/territories/${territoryId}/employees/${farmUserId}/productivity-score?month=${month}&year=${year}`;
  return getData(url, {
    sendTokenInHeader: true,
    basePath: process.env.REACT_APP_CORE_API_BASEPATH,
  }).then(res => res.json());
}
